import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AIInnovationNetworkPage from "@/pages/AIInnovationNetworkPage";

export const Route = createFileRoute("/ai-network")({
  head: () => pageHead("AI Innovation Network | Connect. Collaborate. Innovate Together.", "Join the AI Innovation Network: AI professionals and enthusiasts, technology companies, academic institutions, government agencies, and nonprofits connecting around high-impact AI opportunities.", "/ai-network", false),
  component: AIInnovationNetworkPage,
});
